@if (!incident) {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 bc-mono-white radius-16 ">
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
}

@if (incident) {
    <mat-expansion-panel
        [hideToggle]="Spinner.isShown('initForms')"
        [disabled]="Spinner.isShown('initForms')">
        <mat-expansion-panel-header class="w-100"
                                    [class.loading]="Spinner.isShown('initForms')"
                                    fxLayout="start space-between">
            <mat-panel-title class="no-wrap t2-semi-bold">
                {{ 'i18n_af_contactDetailsInformation' | translate }}
            </mat-panel-title>
            @if (Spinner.isShown('initForms')) {
                <mat-panel-description fxLayoutAlign="end">
                    <ui-kit-spinner [diameter]="16" [strokeWidth]="3" spinnerIds="initForms"/>
                </mat-panel-description>
            }
        </mat-expansion-panel-header>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </mat-expansion-panel>
}

<ng-template #formTemplate>
    @if (form) {
        <div [fxHide]="Spinner.isShown('initForms')" fxLayout="column" fxLayoutAlign="start start" class="w-100">
            <mat-accordion class="w-100">
                @for (contactForm of form.controls?.contacts?.controls; track trackByContactIndex(index, contactForm); let
                    index = $index; let last = $last) {
                    <af-contact-details-expansion-panel
                        [contactForm]="contactForm"
                        [expanded]="!Spinner.isShown('initForms') && last"
                        [showDeleteButton]="showDeleteButton"
                        [showAddContactButton]="!incident && mode === 'edit' && last"
                        [isAddContactButtonDisabled]="form.invalid"
                        [index]="index"
                        [viewIndex]="index + 1"
                        [msisdnPredefinedValue]="msisdnPredefinedValue"
                        [msisdnReadOnly]="(phoneDisabled && !!contactForm.value.id) || (mode === 'edit' && !!msisdnPredefinedValue)"
                        [hidePanel]="mode === 'edit'"
                        [existingAttachments]="existingAttachmentsMap.get(contactForm)"
                        (deleteContactListener)="deleteContact($event)"
                        (addNewContactListener)="createContactForm()"
                        (addLinkListener)="addSuspiciousLink(contactForm)"
                        (removeLinkListener)="removeSuspiciousLink(contactForm, $event)"/>
                }
            </mat-accordion>

            @if (!incident && mode !== 'edit' && form.controls?.contacts?.controls?.length) {
                <ui-kit-button
                    type="text"
                    class="mt-24"
                    fxFlexAlign="start"
                    iconPosition="left"
                    [disabled]="form.invalid"
                    [label]="'i18n_af_buttonAddContact' | translate"
                    icon="ic_add_circle"
                    (clickListener)="createContactForm()"/>
            }

            @if (!incident && !mode && !hideDefaultButtons) {
                <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-40 w-824"
                     [class.pl-24]="!incident"
                     [class.pr-24]="!incident"
                     [class.pb-24]="!incident">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <ui-kit-button spinnerId="submit"
                                       [disabled]="form.invalid"
                                       (clickListener)="submit()"
                                       [label]="'i18n_af_buttonNext' | translate"/>
                        <ui-kit-button class="ml-16"
                                       color="accent"
                                       buttonType="button"
                                       type="text"
                                       (clickListener)="cancel.emit()"
                                       [label]="'i18n_af_buttonCancel' | translate"/>
                    </div>
                    <ui-kit-button type="secondary"
                                   (clickListener)="skipStep()"
                                   [label]="'i18n_af_buttonSkip' | translate"/>
                </div>
            }
        </div>
    }
</ng-template>
